import PropTypes from 'prop-types'

import { TpmsIssueSeverityNames } from '../../models/tpms/tpms-issue-severity-names-enum'
import { TpmsIssueTypes } from '../../models/tpms/tpms-issue-types-enum'
import { TpmsTireLocations } from '../../models/tpms/tpms-tire-locations-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'

/**
 * @typedef {Object} TpmsTireIssue
 * @property {number} axle
 * @property {Array<string>} positions
 * @property {string} severity
 * @property {ISO8601} time
 * @property {string} type
 */
export const tpmsTireIssuePropType = PropTypes.shape({
    axle: PropTypes.number,
    positions: PropTypes.arrayOf(PropTypes.oneOf(Object.values(TpmsTireLocations))),
    severity: PropTypes.oneOf(Object.values(TpmsIssueSeverityNames)),
    time: iso8601PropType,
    type: PropTypes.oneOf(Object.values(TpmsIssueTypes))
})
